import React from 'react';

const IconCreditCard = ({ onClick, color = '#141029' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" onClick={onClick}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0L24 0 24 24 0 24z" transform="translate(-2 -4)" />
      <path fill={color} fillRule="nonzero" d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm-1 14H5c-.55 0-1-.45-1-1v-6h16v6c0 .55-.45 1-1 1zm1-9H4V6h16v3z" transform="translate(-2 -4)" />
    </g>
  </svg>

);

export default IconCreditCard;
